import React from 'react';
import { render } from 'react-dom';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

const photos = [
{ src: 'img/Screen Shot 2018-05-01 at 1.54.49 PM.png', width: 1580, height: 1030 },
{ src: 'img/artsy_01.jpg', width: 1128, height: 880 },
{ src: 'img/artsy_02.png', width: 1680, height: 1050 },
{ src: 'img/artsy_03.png', width: 1000, height: 1055 },
{ src: 'img/artsy_04.png', width: 4000, height: 2300 },
{ src: 'img/artsy_05.png', width: 6000, height: 1412 },
{ src: 'img/artsy_06.png', width: 1288, height: 1056 },
{ src: 'img/artsy_08.png', width: 7015, height: 4960 },
{ src: 'img/bikescore_modeshare.jpg', width: 1224, height: 954 },
{ src: 'img/bikescore_slope_bw.jpg', width: 2048, height: 1822 },
{ src: 'img/bikescore_slope_bw_rainier.jpg', width: 1292, height: 1136 },
{ src: 'img/bikescore_slope_color_ny.jpg', width: 672, height: 1256 },
{ src: 'img/bikescore_slope_color_seattle.jpg', width: 1616, height: 1400 },
{ src: 'img/bikescore_slope_color_sf.jpg', width: 1318, height: 1140 },
{ src: 'img/bikescore_total.jpg', width: 1684, height: 1318 },
{ src: 'img/bikescore_transitscore.png', width: 1200, height: 1361 },
{ src: 'img/bostonmaps_01.jpg', width: 554, height: 502 },
{ src: 'img/bostonmaps_rent_glitch.jpg', width: 607, height: 600 },
{ src: 'img/bostonmaps_rent_round.jpg', width: 1346, height: 1356 },
{ src: 'img/brain.png', width: 1184, height: 1184 },
{ src: 'img/bustracker_gps.png', width: 4000, height: 4000 },
{ src: 'img/bustracker_predict_01.png', width: 1562, height: 985 },
{ src: 'img/bustracker_predict_02.png', width: 2100, height: 1240 },
{ src: 'img/bustracker_predict_03.png', width: 2100, height: 1240 },
{ src: 'img/bustracker_probmodel_01.png', width: 2815, height: 1167 },
{ src: 'img/bustracker_probmodel_02.png', width: 2085, height: 1005 },
{ src: 'img/bustracker_probmodel_03.png', width: 2085, height: 1005 },
{ src: 'img/bustracker_timeline_01.png', width: 4000, height: 500 },
{ src: 'img/bustracker_timeline_02.png', width: 4000, height: 500 },
{ src: 'img/bustracker_timeline_03.png', width: 4000, height: 500 },
{ src: 'img/dotmap.png', width: 10800, height: 7200 },
{ src: 'img/dotmap_ny_01.png', width: 1610, height: 1558 },
{ src: 'img/dotmap_ny_02.png', width: 1590, height: 1560 },
{ src: 'img/dotmap_ny_03.png', width: 1592, height: 1566 },
{ src: 'img/gpsmaps_country.jpg', width: 1009, height: 589 },
{ src: 'img/gpsmaps_portland.jpg', width: 2048, height: 1448 },
{ src: 'img/gpsmaps_seattle.jpg', width: 391, height: 485 },
{ src: 'img/gpsmaps_slope.png', width: 1280, height: 384 },
{ src: 'img/home_exterior.png', width: 1576, height: 1760 },
{ src: 'img/home_plan.jpg', width: 2048, height: 1314 },
{ src: 'img/hubway_01.png', width: 1710, height: 930 },
{ src: 'img/hubway_02.png', width: 2104, height: 1360 },
{ src: 'img/hubway_04.png', width: 1896, height: 1312 },
{ src: 'img/hubway_05.png', width: 1201, height: 925 },
{ src: 'img/jobaccess.png', width: 3000, height: 3168 },
{ src: 'img/jobaccess_01.jpg', width: 1646, height: 1212 },
{ src: 'img/jobaccessratio.png', width: 3507, height: 2480 },
{ src: 'img/lidar_01.jpg', width: 1402, height: 1242 },
{ src: 'img/lidar_02.jpg', width: 1790, height: 1170 },
{ src: 'img/lidar_03.jpg', width: 1920, height: 1080 },
{ src: 'img/lidar_04.jpg', width: 2000, height: 2000 },
{ src: 'img/lidar_05.jpg', width: 1729, height: 2048 },
{ src: 'img/lidar_06.jpg', width: 994, height: 1014 },
{ src: 'img/lidar_07.jpg', width: 1426, height: 2939 },
{ src: 'img/lidar_09.png', width: 1852, height: 1547 },
{ src: 'img/lidar_11.png', width: 4512, height: 850 },
{ src: 'img/lidar_12.png', width: 1910, height: 2003 },
{ src: 'img/lidar_13.png', width: 1853, height: 1548 },
{ src: 'img/lidar_14.png', width: 1852, height: 1547 },
{ src: 'img/lidar_glitch_bre.png', width: 1920, height: 1080 },
{ src: 'img/lidar_home.jpg', width: 1468, height: 1262 },
{ src: 'img/lidar_house_01.jpg', width: 960, height: 540 },
{ src: 'img/lidar_house_03.jpg', width: 1468, height: 1262 },
{ src: 'img/lidar_house_04.jpg', width: 1920, height: 1080 },
{ src: 'img/lidar_house_05.jpg', width: 1920, height: 1080 },
{ src: 'img/lidar_house_06.jpg', width: 1998, height: 1198 },
{ src: 'img/lidar_map_downtown.png', width: 2020, height: 1885 },
{ src: 'img/lidar_map_home.jpg', width: 1426, height: 2939 },
{ src: 'img/lidar_map_shadow_carkeek.jpg', width: 1910, height: 2003 },
{ src: 'img/lidar_map_shadow_finhill.jpg', width: 1520, height: 1368 },
{ src: 'img/lidar_map_steds.png', width: 1852, height: 1547 },
{ src: 'img/lidar_map_trees.png', width: 1920, height: 1080 },
{ src: 'img/lidar_map_trees_steds.png', width: 1852, height: 1547 },
{ src: 'img/lidar_map_uw_01.png', width: 2687, height: 3182 },
{ src: 'img/lidar_misc.jpg', width: 1080, height: 1920 },
{ src: 'img/lidar_misc_02.jpg', width: 1630, height: 980 },
{ src: 'img/lidar_occlusion_uw.jpg', width: 1729, height: 2048 },
{ src: 'img/lidar_plaster_uw.jpg', width: 1920, height: 1080 },
{ src: 'img/lidar_room.jpg', width: 1090, height: 1328 },
{ src: 'img/lidar_room2.jpg', width: 1804, height: 842 },
{ src: 'img/lidar_room3.jpg', width: 960, height: 540 },
{ src: 'img/metrokc_service_changes.png', width: 2000, height: 1638 },
{ src: 'img/misc.jpg', width: 1470, height: 1028 },
{ src: 'img/misc_02.jpg', width: 1838, height: 1220 },
{ src: 'img/misc_03.jpg', width: 1808, height: 1240 },
{ src: 'img/misc_07.png', width: 1000, height: 1000 },
{ src: 'img/misc_names.jpg', width: 1272, height: 1224 },
{ src: 'img/paperseattle)04.png', width: 1920, height: 1080 },
{ src: 'img/paperseattle_01.png', width: 1920, height: 1080 },
{ src: 'img/paperseattle_02.png', width: 3840, height: 2160 },
{ src: 'img/paperseattle_03.png', width: 1920, height: 1080 },
{ src: 'img/physical_01.jpg', width: 600, height: 800 },
{ src: 'img/physical_02.jpg', width: 1080, height: 1440 },
{ src: 'img/projectedvmt.png', width: 2116, height: 1126 },
{ src: 'img/quantself.png', width: 1455, height: 1574 },
{ src: 'img/quantself_01.jpg', width: 1005, height: 515 },
{ src: 'img/quantself_02.jpg', width: 915, height: 629 },
{ src: 'img/quantself_03.jpg', width: 1025, height: 604 },
{ src: 'img/quantself_04.jpg', width: 2880, height: 1440 },
{ src: 'img/quantself_05.jpg', width: 707, height: 702 },
{ src: 'img/quantself_06.jpg', width: 914, height: 1308 },
{ src: 'img/quantself_airplane.jpg', width: 991, height: 582 },
{ src: 'img/quantself_fitbit.png', width: 1767, height: 309 },
{ src: 'img/robots.jpg', width: 1289, height: 979 },
{ src: 'img/ruinedcity.jpg', width: 10771, height: 5385 },
{ src: 'img/sanfran_misc_01.png', width: 1000, height: 1000 },
{ src: 'img/sdc_future.png', width: 1226, height: 989 },
{ src: 'img/sdcsafety.png', width: 1512, height: 1768 },
{ src: 'img/seattle_misc.jpg', width: 1004, height: 874 },
{ src: 'img/seattle_misc_01.jpg', width: 537, height: 685 },
{ src: 'img/shelves.jpg', width: 1122, height: 1344 },
{ src: 'img/sonar.png', width: 1437, height: 963 },
{ src: 'img/sonar_03.png', width: 1522, height: 987 },
{ src: 'img/sonar_05.png', width: 1245, height: 896 },
{ src: 'img/sonar_06.png', width: 1437, height: 963 },
{ src: 'img/sonar_07.png', width: 2055, height: 1683 },
{ src: 'img/sonar_artsy.png', width: 955, height: 988 },
{ src: 'img/spt_01.jpg', width: 2000, height: 1600 },
{ src: 'img/spt_02.png', width: 2000, height: 2000 },
{ src: 'img/spt_03.png', width: 2222, height: 2524 },
{ src: 'img/spt_06.png', width: 3000, height: 2347 },
{ src: 'img/spt_08.png', width: 1448, height: 952 },
{ src: 'img/subway_matrix.jpg', width: 606, height: 589 },
{ src: 'img/transpo_01.jpg', width: 842, height: 566 },
{ src: 'img/transpo_03.jpg', width: 1028, height: 1050 },
{ src: 'img/transpo_04.jpg', width: 1588, height: 1374 },
{ src: 'img/transpo_05.jpg', width: 1154, height: 1336 },
{ src: 'img/transpo_06.jpg', width: 1232, height: 772 },
{ src: 'img/transpo_07.png', width: 546, height: 479 },
{ src: 'img/transpo_08.jpg', width: 1786, height: 1102 },
{ src: 'img/transpo_bike.png', width: 7829, height: 5293 },
{ src: 'img/transpo_carmiles.png', width: 2130, height: 1183 }
];


class App extends React.Component {
  constructor() {
    super();
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }
  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }
  render() {
    return (
      <div>
        <Gallery photos={photos} onClick={this.openLightbox} />
        <Lightbox images={photos}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />
      </div>
    )
  }
}
render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js